import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { StorageConfig, StorageService as OldStorageService } from './storage.service';
import { StorageService, WebStorageService } from '@techniek-team/storage';

/**
 * @deprecated Package is moved to @techniek-team/storage this version will be removed in the next major version. v23
 */
export function provideStorage(
  storageConfig: StorageConfig,
  ...features: (Provider | EnvironmentProviders)[][]
) {
  return [
    {
      provide: OldStorageService,
      useFactory: () => new WebStorageService(storageConfig),
    },
    {
      provide: StorageService,
      useFactory: () => new WebStorageService(storageConfig),
    },
    ...features,
    provideEnvironmentInitializer(() => {
      const storage = inject(StorageService);
      void storage.create();
    }),
  ];
}
